/* co-home-6 "Reviews" carousel controls — wired to the co-flickity instance. Normally it wires on
   co-flickity's co-flickity:init event (which also re-fires on the editor's section:load). But that
   event can be MISSED when the section loads the Flickity lib itself (off the homepage): co-flickity
   then fires co-flickity:init synchronously the instant it runs, which can be before this deferred
   script has registered its listener. So we ALSO scan for carousels co-flickity already initialised
   (it stores the instance on el.__flkty) and wire those — making this load-order independent.
   Provides three bespoke behaviors co-flickity doesn't:
     - prev/next arrows (they sit in .co-home-6-slider-wrapper, outside the carousel's direct
       parent, so co-flickity's built-in arrow wiring can't reach them);
     - position classes (is-active / is-prev / is-next / is-prev-prev / is-next-next) so the CSS
       can fade everything except the nearby cards;
     - a center-distance translateY morph on each cell's .carousel-cell-transform-1 layer.
   Position + morph are derived from each cell's LIVE distance from the viewport centre and
   recomputed on 'scroll'/'dragMove' (not just 'select'), so they update WHILE dragging, not
   only on release. The morph is its own layer (transform on .carousel-cell-transform-1),
   separate from the cell-frame's rotateZ tilt + opacity focus, so nothing fights. Arrow
   handlers are stored/removed (the editor can reuse nodes); the morph is skipped under reduced
   motion (positions/classes still update). */
(function () {
  if (window.__coHome6Controls) return;
  window.__coHome6Controls = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var POS_OFFSETS = [[0, 'is-active'], [-1, 'is-prev'], [1, 'is-next'], [-2, 'is-prev-prev'], [2, 'is-next-next']];
  var TY_PREV = -40, TY_NEXT = -60; // px, peak translateY for the morph

  /* translateY (px) for a cell at signed distance `d` (in cell-widths) from centre. Rises toward
     centre; eases back out to 0 by ±2 cell-widths. Copied from the original co-home-6 init. */
  function morphY(d) {
    if (d >= 1 && d <= 2) return TY_NEXT * (1 - (d - 1));
    if (d >= 0 && d < 1) return TY_NEXT * d;
    if (d >= -2 && d <= -1) return TY_PREV * (1 - (Math.abs(d) - 1));
    if (d >= -1 && d < 0) return TY_PREV * Math.abs(d);
    return 0;
  }

  function wire(el, flkty) {
    if (!flkty || el.__coH6Wired === flkty) return; // don't double-wire the same instance
    el.__coH6Wired = flkty;

    var wrapper = el.closest('.co-home-6-slider-wrapper');
    var prevBtn = wrapper && wrapper.querySelector('.co-home-6-slider-prev button');
    var nextBtn = wrapper && wrapper.querySelector('.co-home-6-slider-next button');

    function bindClick(btn, fn) {
      if (!btn) return;
      if (btn.__coH6Click) btn.removeEventListener('click', btn.__coH6Click);
      btn.__coH6Click = fn;
      btn.addEventListener('click', fn);
    }
    bindClick(prevBtn, function () { flkty.previous(); });
    bindClick(nextBtn, function () { flkty.next(); });

    function update() {
      var cells = flkty.cells || [];
      var n = cells.length;
      var viewport = flkty.viewport;
      if (!n || !viewport) return;

      /* Read pass. For each cell compute:
           - dists[i]: signed distance of the cell CENTRE from the viewport centre (cell-widths),
             used by the morph;
           - left: the cell's LEFT edge relative to the viewport's left edge.
         The active card is the one aligned to the left (this carousel is cellAlign:'left'), i.e.
         left edge nearest the viewport's left — NOT the card nearest centre (that's the MIDDLE
         visible card, which is what made the focus land on cards 2-3-4 instead of 1-2-3). */
      var vpRect = viewport.getBoundingClientRect();
      var vpCenter = viewport.offsetWidth / 2;
      var dists = new Array(n);
      var activeIdx = 0;
      var minLeft = Infinity;
      for (var i = 0; i < n; i++) {
        var r = cells[i].element.getBoundingClientRect();
        var left = r.left - vpRect.left;
        dists[i] = (left + r.width / 2 - vpCenter) / r.width;
        if (Math.abs(left) < minLeft) { minLeft = Math.abs(left); activeIdx = i; }
      }

      /* Write pass — position classes (relative to the cell nearest centre, wrapping). */
      for (var j = 0; j < n; j++) {
        cells[j].element.classList.remove('is-active', 'is-prev', 'is-next', 'is-prev-prev', 'is-next-next');
      }
      for (var p = 0; p < POS_OFFSETS.length; p++) {
        var idx = ((activeIdx + POS_OFFSETS[p][0]) % n + n) % n;
        cells[idx].element.classList.add(POS_OFFSETS[p][1]);
      }

      /* Write pass — morph (skipped under reduced motion; classes above still update). */
      if (!reduce.matches) {
        for (var k = 0; k < n; k++) {
          var t = cells[k].element.querySelector('.carousel-cell-transform-1');
          if (t) t.style.transform = 'translateY(' + morphY(dists[k]) + 'px)';
        }
      }
    }

    flkty.on('scroll', update);     // continuous — fires WHILE dragging + on momentum
    flkty.on('dragMove', update);
    flkty.on('select', update);
    flkty.on('resize', update);
    update();
  }

  /* Real-time path: co-flickity fires this once per carousel + again on every editor re-init. */
  document.addEventListener('co-flickity:init', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('.co-home-6 .main-carousel')) return;
    wire(el, e.detail && e.detail.flickity);
  });

  /* Load-order safety net: wire any carousel co-flickity already initialised before this script
     registered its listener (it stores the instance on el.__flkty). Runs once the DOM is ready so
     the deferred co-flickity.js has had its chance to run, regardless of script order. */
  function scanExisting() {
    var list = document.querySelectorAll('.co-home-6 .main-carousel');
    for (var i = 0; i < list.length; i++) {
      if (list[i].__flkty) wire(list[i], list[i].__flkty);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanExisting);
  } else {
    scanExisting();
  }
})();
